import React from 'react';
import Sensor from "../../../components/pages/grid/Sensor/Sensor";

const SensorGridPage = () => {
    return <Sensor />
};

export default SensorGridPage;
